import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideArrowUpDown = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m21 16-4 4-4-4m4 4V4M3 8l4-4 4 4M7 4v16"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLucideArrowUpDown);
const Memo = memo(ForwardRef);
export default Memo;
